<script>
export default {
  name: 'SocialSoundCloud',
  props: {
    url: String,
  },
};
</script>

<template>
  <a :href="url" target="_blank">
    <svg class="ico"><use xlink:href="#ico-soundcloud"></use></svg>
  </a>
</template>

<style scoped lang="scss"></style>
